var ValueJS = ValueJS || {};

ValueJS.AutoPopup = function() {

    var _defaults = {
        "bsModalSelector" : "#vlnc-auto-popup"
    }

    var _initialized = false;

    const _modal = $(_defaults.bsModalSelector);
    const _bsModal = _modal.length ? new bootstrap.Modal(_modal[0]) : null;
    const _msgKey = _modal.length ? _modal.data('msg-key') : null;
    const _popupDelayKey = _modal.length ? _modal.data('popup-delay') : 0;
    const _newsletterBtn = _modal.find('button.btn-primary');

    var _init = function() {
        
        // check if popup is present
        if (_modal.length) {
            
            // only auto display if not shopify theme editor
            if (!Shopify.designMode) {
                
                // check cookie to ensure current message has not yet been seen
                if ($.inArray(_msgKey, _getSeenMsgKeys()) < 0) {
                    
                    // set delay to show popup
                    setTimeout(function() {
                        _bsModal.show();
                    }, (_popupDelayKey * 1000));

                    // remember message key in cookie when popup is displayed
                    _modal.on('shown.bs.modal', function() {
                        _storeMsgKey();
                    });

                    // handle newsletter button
                    if (_newsletterBtn.length) {
                        _newsletterBtn.on('click', function() {
                            let newsletterSection = $('.section--newsletter');
                            if (newsletterSection.length) {
                                ValueJS.SmoothScroll.scroll(newsletterSection);
                            } else {
                                let newsletterBlock =  $('#newsletter-subscription');
                                if (newsletterBlock.length) {
                                    ValueJS.SmoothScroll.scroll(newsletterBlock);
                                }
                                // window.location.href = "/#newsletter-subscription";
                            }
                        });
                    }
                    
                }

            } 
            
            // if in shopify theme editor
            else {

                // add or re-rendered section
                $(document).on('shopify:section:load', function(e) {
                    if (e.detail.sectionId === _modal.data('shopify-section-id')) {
                        if (_modal.is(':visible')) {
                            _bsModal.hide();                            
                        }
                        _bsModal.show();
                    }
                });

                // section deleted or being re-rendered
                $(document).on('shopify:section:unload', function(e) {
                    if (e.detail.sectionId === _modal.data('shopify-section-id')) {
                        if (_modal.is(':visible')) {
                            _bsModal.hide();                            
                        }
                    }
                });

                // section selected
                $(document).on('shopify:section:select', function(e) {
                    if (e.detail.sectionId === _modal.data('shopify-section-id')) {
                        if (_modal.is(':visible')) {
                            _bsModal.hide();                            
                        }
                        _bsModal.show();
                    }
                });

                // section deselected
                $(document).on('shopify:section:deselect', function(e) {
                    if (e.detail.sectionId === _modal.data('shopify-section-id')) {
                        if (_modal.is(':visible')) {
                            _bsModal.hide();                            
                        }
                    }
                });

            }
        }
    }

    var _getSeenMsgKeys = function() {
        let cookieValue = Cookies.get('popupmsgs');
        if (!cookieValue) {
            return [];
        } else {
            return cookieValue.split("|")
        }
    }

    var _storeMsgKey = function() {
        // retrieve current cookie values
        let messageKeys = _getSeenMsgKeys();
        if ($.inArray(_msgKey, messageKeys) < 0) {
            messageKeys.push(_msgKey);
            Cookies.set('popupmsgs', messageKeys.join('|'), { expires: 24 * 365 * 10 });
        }
    }

    /** PUBLIC API **/
    return {
        init : function() {return _init();},
    };

}();

$(function() {
    ValueJS.AutoPopup.init();
});
